import { ChangedSpaceEvent } from './changed-space-event';
import { FavoriteRecommendation } from './favorite-recommendation';
import { ImageReview } from './image-review';
import { MapAnnotation } from './map-annotation';
import { ObjectZoneRecommendation } from './object-zone-recommendation';
import { SmartScheduleRecommendation } from './schedule-recommendation';

export class QAInsightEvent {
  public robot_id: string;
  public campaign_id: string;
  public robot_name?: string;
  public p2map_id?: string = null;
  public map_annotation?: MapAnnotation = null;
  public changed_space_event?: ChangedSpaceEvent = null;
  public object_zone_recommendation?: ObjectZoneRecommendation = null;
  public schedule_recommendation?: SmartScheduleRecommendation = null;
  public favorite_recommendation?: FavoriteRecommendation = null;
  public image_review?: ImageReview = null;
}
